export * from './baProfilePicture.pipe';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/pipes/baProfilePicture/index.ts